export enum SavePdbType {
  Offer = 1,
  Summary = 2,
}
